export const applyWithOptionalToNull =
  <T, V>(func: (value: T) => V): ((value: T | null | undefined) => V | null) =>
  (value: T | null | undefined): V | null =>
    value !== null && value !== undefined ? func(value as T) : null;
